export default __webpack_public_path__ + "static/media/Click1.27ba3fbb.mp3";